/**
 * Generated by "@vuepress/internal-root-mixins"
 */
import m0 from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/@vuepress+core@1.9.10_@vue+compiler-sfc@3.4.23_ejs@2.7.4_hogan.js@3.0.2_lodash@4.17.21_underscore@1.13.6/node_modules/@vuepress/core/lib/client/root-mixins/updateMeta.js"
import m1 from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/@vuepress+plugin-active-header-links@1.9.10/node_modules/@vuepress/plugin-active-header-links/clientRootMixin.js"
import m2 from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/@vuepress+plugin-nprogress@1.9.10/node_modules/@vuepress/plugin-nprogress/clientRootMixin.js"
import m3 from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/vuepress-plugin-smooth-scroll@0.0.3/node_modules/vuepress-plugin-smooth-scroll/lib/clientRootMixin.js"
import m4 from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/vuepress-plugin-zooming@1.1.8/node_modules/vuepress-plugin-zooming/lib/clientRootMixin.js"
import m5 from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/vuepress-plugin-one-click-copy@1.0.6/node_modules/vuepress-plugin-one-click-copy/bin/clientRootMixin.js"

export default [
  m0,
  m1,
  m2,
  m3,
  m4,
  m5
]